import http from './http'

export default {
  member: {
    getMember (id) {
      return http.get('/member/getmember', {id: id})
    },
    getMemberList (search, pageConfig) {
      return http.get('/member/getmemberlist', {
        shopId: search.shop,
        keyword: search.keyword,
        memberLevel: search.memberLevel,
        status: search.status,
        pageIndex: pageConfig.pageIndex,
        pageSize: pageConfig.pageSize
      })
    },
    getStatusList () {
      return http.get('/member/getstatuslist')
    },
    getSendModeList () {
      return http.get('/member/getsendmodelist')
    },
    create (model) {
      return http.post('/member/create', model)
    },
    update (model) {
      return http.post('/member/update', model)
    }
  },
  memberLevel: {
    get (id) {
      return http.get('/member/memberlevel/get', {id: id})
    },
    getList () {
      return http.get('/member/memberlevel/getlist')
    },
    create (model) {
      return http.post('/member/memberlevel/create', model)
    },
    update (model) {
      return http.post('/member/memberlevel/update', model)
    },
    delete (id) {
      return http.post('/member/memberlevel/delete', id)
    }
  },
  memberTag: {
    get (id) {
      return http.get('/member/membertag/get', { id: id })
    },
    getList () {
      return http.get('/member/membertag/getlist')
    },
    create (model) {
      return http.post('/member/membertag/create', model)
    },
    update (model) {
      return http.post('/member/membertag/update', model)
    },
    delete (id) {
      return http.post('/member/membertag/delete', id)
    }
  },
  memberGift: {
    get (id) {
      return http.get('/member/membergift/get', { id: id })
    },
    getList (search, pageConfig) {
      return http.get('/member/membergift/getlist', {
        keyword: search.keyword,
        minPoints: search.minPoints,
        maxPoints: search.maxPoints,
        pageIndex: pageConfig.pageIndex,
        pageSize: pageConfig.pageSize
      })
    },
    create (model) {
      return http.post('/member/membergift/create', model)
    },
    update (model) {
      return http.post('/member/membergift/update', model)
    },
    delete (id) {
      return http.post('/member/membergift/delete', id)
    }
  },
  memberCardClass: {
    get (id) {
      return http.get('/member/membercardclass/get', { id: id })
    },
    getList () {
      return http.get('/member/membercardclass/getlist')
    },
    getCardTypeList () {
      return http.get('/member/membercardclass/getcardtypelist')
    },
    create (model) {
      return http.post('/member/membercardclass/create', model)
    },
    update (model) {
      return http.post('/member/membercardclass/update', model)
    },
    delete (id) {
      return http.post('/member/membercardclass/delete', id)
    }
  },
  memberCardRechargePlan: {
    get (id) {
      return http.get('/member/membercardrechargeplan/get', { id: id })
    },
    getList () {
      return http.get('/member/membercardrechargeplan/getlist')
    },
    create (model) {
      return http.post('/member/membercardrechargeplan/create ', model)
    },
    update (model) {
      return http.post('/member/membercardrechargeplan/update ', model)
    },
    delete (id) {
      return http.post('/member/membercardrechargeplan/delete', id)
    }
  },
  memberQuery: {
    getMoneyRecordList (search, pageConfig) {
      return http.get('/member/memberquery/getmoneyrecordlist', {
        shopId: search.shop,
        stallId: search.stallId,
        merchantId: search.merchantId,
        keyword: search.keyword,
        startDate: search.date[0],
        endDate: search.date[1],
        type: search.type,
        pageIndex: pageConfig.pageIndex,
        pageSize: pageConfig.pageSize
      })
    },
    getMoneyRecordTypeList () {
      return http.get('/member/memberquery/getmoneyrecordtypelist')
    },
    getPointsRecordList (search, pageConfig) {
      return http.get('/member/memberquery/getpointsrecordlist', {
        shopId: search.shop,
        keyword: search.keyword,
        date: search.date,
        pageIndex: pageConfig.pageIndex,
        pageSize: pageConfig.pageSize
      })
    },
    getOperateRecordList (search, pageConfig) {
      return http.get('/member/memberquery/getoperaterecordlist', {
        shopId: search.shop,
        keyword: search.keyword,
        date: search.date,
        type: search.status,
        pageIndex: pageConfig.pageIndex,
        pageSize: pageConfig.pageSize
      })
    },
    getOperateRecordTypeList () {
      return http.get('/member/memberquery/getoperaterecordtypelist')
    },
    getMemberExpenseAnalysisList (search, pageConfig) {
      return http.get('/member/memberquery/getmemberexpenseanalysislist', {
        startDate: search.date[0],
        endDate: search.date[1],
        minMoney: search.minMoney,
        maxMoney: search.maxMoney,
        minTimes: search.minTimes,
        maxTimes: search.maxTimes,
        memberTagIds: search.memberTagIds,
        pageIndex: pageConfig.pageIndex,
        pageSize: pageConfig.pageSize
      })
    },
    getMemberCardOperateCountList (search, pageConfig) {
      return http.get('/member/memberquery/getmembercardoperatecountlist', {
        startDate: search.date[0],
        endDate: search.date[1],
        shopId: search.shopId,
        pageIndex: pageConfig.pageIndex,
        pageSize: pageConfig.pageSize
      })
    },
    getExpenseRecordList (memberCardId, pageConfig) {
      return http.get('/member/memberquery/getexpenserecordlist', {
        memberCardId: memberCardId,
        pageIndex: pageConfig.pageIndex,
        pageSize: pageConfig.pageSize
      })
    },
    getBillSalePagedListByExpenseRecord (id, pageConfig) {
      return http.get('/member/memberquery/getbillsalepagedlistbyexpenserecord', {
        memberCardMoneyRecordId: id,
        pageIndex: pageConfig.pageIndex,
        pageSize: pageConfig.pageSize
      })
    },
    getMemberCardBalanceList (search, pageConfig) {
      return http.get('/member/memberquery/getmembercardbalancelist', {
        shopId: search.shop,
        classId: search.classId,
        cardCode: search.cardCode,
        recharge: search.recharge,
        expense: search.expense,
        balance: search.balance,
        pageIndex: pageConfig.pageIndex,
        pageSize: pageConfig.pageSize
      })
    }
  },
  memberRandomDiscount: {
    get (id) {
      return http.get('/member/memberrandomdiscount/get', { id: id })
    },
    getList (shopId) {
      return http.get('/member/memberrandomdiscount/getlist', { shopId: shopId })
    },
    set (model) {
      return http.post('/member/memberrandomdiscount/set', model)
    }
  },
  memberAbnormalRecord: {
    getMemberMoneyRecordAbnormalList (search, pageConfig) {
      return http.get('/member/memberabnormalrecord/getmembermoneyrecordabnormallist', {
        shopId: search.shop,
        date: search.date,
        pageIndex: pageConfig.pageIndex,
        pageSize: pageConfig.pageSize
      })
    },
    adjustRecord (model) {
      return http.post('/member/memberabnormalrecord/adjustrecord', model)
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/member.js